import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import type { CompanyFilePaginatedRequest } from 'types'

import { companyKeyFactory } from '../company.queries'
import { companyFileList } from './company-file.service'

export const companyFileKeyFactory = {
  list: (companyUuid?: string, request?: CompanyFilePaginatedRequest) => [
    ...companyKeyFactory.base(),
    'file',
    ...(companyUuid ? [companyUuid] : []),
    ...(request ? [request] : []),
  ],
}

export interface QueryCompanyFileListProps {
  companyUuid: string
  request: CompanyFilePaginatedRequest
}

export const queryCompanyFileList = ({
  companyUuid,
  request,
}: QueryCompanyFileListProps) =>
  queryOptions({
    queryKey: companyFileKeyFactory.list(companyUuid, request),
    queryFn: () => companyFileList(companyUuid, request),
    placeholderData: keepPreviousData,
  })
